import { useState, useEffect } from "react";
import { toast } from "sonner";

import api from "../../api";
import { useGlobalContext } from "../../context";
import UserSideNav from "../components/UserSideNav";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut, BiSolidWallet } from "react-icons/bi";
import userDashLinks from "./userDashLinks";
import { BsChevronDown } from "react-icons/bs";
import { FaBitcoin, FaEthereum } from "react-icons/fa";
import { BiSolidDollarCircle } from "react-icons/bi";
import spinner from "../../images/SpinnerTrans.svg";

const cryptoOptions = [
  {
    key: "BTC",
    label: "BTC",
    icon: <FaBitcoin className="text-yellow-500 shrink-0" />,
  },
  {
    key: "ETH",
    label: "ETH",
    icon: <FaEthereum className="text-blue-400 shrink-0" />,
  },
  {
    key: "USDT",
    label: "USDT (ERC20)",
    icon: <BiSolidDollarCircle className="text-[#868e98] shrink-0" />,
  },
  {
    key: "SOL",
    label: "SOL",
    icon: <span className="text-[#9945FF] text-[14px] font-bold shrink-0">◎</span>,
  },
];

const Usertransfer = () => {
  const { allUserMongoData } = useGlobalContext();

  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  // asset dropdown
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("BTC");

  const selectedOption = cryptoOptions.find((o) => o.key === selectedCrypto);

  // form state
  const [TransferValues, setTransferValues] = useState({
    amount: "",
    walletaddress: "",
    cryptotype: "BTC",
  });
  const [isLoadingBtn, updateisLoadingBtn] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const submitTransfer = async (e) => {
    e.preventDefault();
    updateisLoadingBtn(true);
    setIsButtonDisabled(true);

    try {
      const transferPost = await api.post("/api/user/transfer", {
        ...TransferValues,
      });
      const transferData = transferPost.data;

      if (transferData.errMsg) {
        setTimeout(() => {
          toast.error(transferData.errMsg);
          updateisLoadingBtn(false);
          setIsButtonDisabled(false);
        }, 3000);
      } else {
        setTransferValues({
          amount: "",
          walletaddress: "",
          cryptotype: selectedCrypto,
        });
        setTimeout(() => {
          toast.success(transferData.successMsg);
          updateisLoadingBtn(false);
          setIsButtonDisabled(false);
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        updateisLoadingBtn(false);
        setIsButtonDisabled(false);
      }, 3000);
    }
  };

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1] " />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>

            <div className="relative flex space-x-2">
              <div className="relative flex justify-center items-center space-x-2 min-h-[38px] py-2 px-4 bg-[#181C26] border border-[#1f2535] rounded-lg transition-all ease-in duration-200 hover:border-[#473ECD]">
                <BiSolidWallet className="text-[14px] text-[#A9ABAD]" />
                <p className="text-[12px] text-[#A9ABAD]">
                  $
                  {allUserMongoData && allUserMongoData.balance
                    ? allUserMongoData.balance.toLocaleString()
                    : "0"}
                </p>
              </div>
            </div>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Transfer Funds</h3>
          <p className="text-[#A9ABAD] text-[14px]">
            Send crypto to an external wallet address.
          </p>
        </div>

        {/* tab switcher */}
        <div className="flex items-center space-x-1 mb-8 bg-[#181C26] border border-[#1f2535] rounded-lg p-1 w-fit">
          <Link
            to="/user/deposit"
            className="px-5 py-2 rounded-md text-[13px] text-[#A9ABAD] hover:text-white transition-colors"
          >
            Deposit
          </Link>
          <div className="px-5 py-2 rounded-md text-[13px] text-white bg-[#0d1017]">
            Transfer
          </div>
        </div>

        {/* form */}
        <form
          onSubmit={submitTransfer}
          className="w-full flex flex-col space-y-4 sm:w-[420px]"
        >
          <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col">
            {/* asset selector */}
            <div className="w-full flex flex-col space-y-2 pb-5">
              <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                Asset
              </label>
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setIsOpen(!isOpen)}
                  className="w-full flex justify-between items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 py-3 text-[13px] text-white"
                >
                  <div className="flex items-center space-x-2">
                    {selectedOption?.icon}
                    <span>{selectedOption?.label}</span>
                  </div>
                  <BsChevronDown
                    className={`text-[#A9ABAD] text-[13px] transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isOpen && (
                  <ul className="absolute top-[calc(100%+4px)] left-0 w-full z-50 bg-[#0d1017] border border-[#1f2535] rounded-lg overflow-hidden">
                    {cryptoOptions.map((opt) => (
                      <li
                        key={opt.key}
                        onClick={() => {
                          setSelectedCrypto(opt.key);
                          setTransferValues({
                            ...TransferValues,
                            cryptotype: opt.key,
                          });
                          setIsOpen(false);
                        }}
                        className="flex items-center space-x-2 px-4 py-3 text-[13px] text-[#A9ABAD] hover:bg-[#181C26] hover:text-white cursor-pointer transition-colors"
                      >
                        {opt.icon}
                        <span>{opt.label}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="w-full h-[1px] bg-[#1f2535]" />

            {/* amount */}
            <div className="w-full flex flex-col space-y-2 py-5">
              <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                Amount
              </label>
              <div className="w-full flex items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 focus-within:border-[#473ECD] transition-colors">
                <span className="text-[#A9ABAD] text-[14px] pr-2">$</span>
                <input
                  type="text"
                  value={TransferValues.amount.replace(/[^0-9.]/g, "")}
                  name="amount"
                  className="appearance-none no-number-arrows w-full h-[48px] bg-inherit text-white text-[16px] focus:outline-none"
                  placeholder="0.00"
                  onBlur={(e) => {
                    setTransferValues({
                      ...TransferValues,
                      [e.target.name]: e.target.value.startsWith("$")
                        ? e.target.value
                        : "$" + e.target.value,
                    });
                  }}
                  onChange={(e) => {
                    setTransferValues({
                      ...TransferValues,
                      [e.target.name]: e.target.value.replace("$", ""),
                    });
                  }}
                />
                <span className="text-[12px] text-[#535963] pl-2 border-l border-[#2e3340] ml-2">
                  USD
                </span>
              </div>
            </div>

            <div className="w-full h-[1px] bg-[#1f2535]" />

            {/* wallet address */}
            <div className="w-full flex flex-col space-y-2 pt-5">
              <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                Wallet Address
              </label>
              <div className="w-full flex items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 focus-within:border-[#473ECD] transition-colors">
                <input
                  type="text"
                  value={TransferValues.walletaddress}
                  name="walletaddress"
                  className="custom-placeholder bg-inherit w-full h-[48px] text-white text-[16px] focus:outline-none"
                  placeholder="Enter destination address"
                  onChange={(e) =>
                    setTransferValues({
                      ...TransferValues,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={isButtonDisabled}
            className="w-full min-h-[44px] flex justify-center items-center text-[14px] font-[500] bg-userDashPurple rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5] disabled:opacity-60"
          >
            {isLoadingBtn ? (
              <img src={spinner} className="w-[26px] h-[26px]" alt="loading" />
            ) : (
              "Continue Transfer"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Usertransfer;
